export default __webpack_public_path__ + "static/media/muscles.cdbe5d1e.png";